import {
  type Option,
  SelectComboField,
} from "components/Forms/SelectCombo/SelectCombo";
import { useCompanies } from "hooks/useCompany";
import type { Company } from "kubb";
import type React from "react";

interface PProps {
  fieldName: string;
  allowNone?: boolean;
}

type Props = PProps;

const CompanySelectDropdown = (props: Props): React.ReactElement => {
  const { fieldName, allowNone } = props;

  const companies = useCompanies() || [];
  let options: Option[] = companies.map((company: Company) => {
    return {
      value: company.company_id,
      label: company.name,
    };
  });

  options = allowNone
    ? [{ value: "", label: "Select Company" }, ...options]
    : options;

  return (
    <SelectComboField
      label={{ label: "Company" }}
      options={options}
      fieldName={fieldName}
    />
  );
};

export default CompanySelectDropdown;
